<template>
  <div :class="bem.b()">
    <!-- 头部搜索 -->
    <header-search
      :throttle-time="throttleTime"
      :search-value="searchValue"
      :is-show-add-btn="isShowAddBtn"
      :on-search-input-change="handleSearchInputChange"
      @click="handleClickAddBtn"
    />
    <!-- 目录标题 -->
    <directory-title
      :is-collapse-menu="isCollapseMenu"
      @collapse-menu="handleCollapseMenu"
    >
      <template #title>
        <slot name="directoryTitle"></slot>
      </template>
    </directory-title>
    <!-- operate-tree -->
    <ll-operate-tree
      v-bind="attrs"
      :operate-dropdown-open="operateDropdownOpen"
      :loading="loading"
      :field-names="fieldNames"
      :tree-data="treeData"
      :expanded-keys="newExpandedKeys"
      @expand="handleTreeExpand"
      @select="handleTreeSelect"
    >
      <!-- switcher-icon-slots -->
      <template #switcherIcon="slots">
        <slot name="switcherIcon" v-bind="slots" />
      </template>
      <!-- icon-slots -->
      <template #icon="slots">
        <slot name="icon" v-bind="slots" />
      </template>
      <!-- title-slots -->
      <template #treeTitle="slots">
        <slot name="treeTitle" v-bind="slots" />
      </template>
      <!-- operate-slot -->
      <template #treeOperate="slots">
        <slot name="treeOperate" v-bind="slots.data" />
      </template>
      <!-- empty-slot -->
      <template #empty>
        <slot name="empty" />
      </template>
    </ll-operate-tree>
    <!-- 操作出现的方式 -->
    <!-- 模态框 -->
    <template v-if="operateWay === 'modal'">
      <ll-modal
        v-bind="modalConfigProps"
        :open="open"
        @ok="handleClickOkBtn"
        @cancel="handleClickCancelBtn"
      >
        <slot name="operateBoxContent" />
      </ll-modal>
    </template>
    <!-- 抽屉 -->
    <template v-else-if="operateWay === 'drawer'">
      <ll-drawer
        v-bind="drawerConfigProps"
        :open="open"
        @confirm="handleClickOkBtn"
        @cancel="handleClickCancelBtn"
        @close="handleClickCloseBtn"
      >
        <slot name="operateBoxContent" />
        <template #footer-left>
          <slot name="drawerFooterLeft" />
        </template>
      </ll-drawer>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { treeSearchProps, treeSearchEmits } from './config'

import HeaderSearch from './components/header-search.vue'
import DirectoryTitle from './components/directory-title.vue'
import { LlOperateTree } from '@ll-plus/components'

// 1.defineOptions
defineOptions({ name: 'LlTreeSearch' })

// 2.props/emits
const props = defineProps(treeSearchProps)
const emits = defineEmits(treeSearchEmits)

// 3.ref
// 是否收起/展开
const isCollapseMenu = ref(false)
const newExpandedKeys = ref<string[]>([])
// 输入框内容
// const searchValue = ref('')
const bem = createNamespace('tree-search')

// 4.hooks
const attrs = useAttrs()

// 5.methods
// 获取所有树的keys
const getTreeDataKeys = (children: any[]) => {
  const keys: any[] = []
  const getKeys = (children: any[]) => {
    if (children) {
      children.forEach(item => {
        keys.push(item[props.fieldNames!['key']!])
        if (item[props.fieldNames!['children']!]) {
          getKeys(item[props.fieldNames!['children']!])
        }
      })
    }
  }
  getKeys(children)
  return keys
}
const handleCollapseMenu = () => {
  isCollapseMenu.value = !isCollapseMenu.value
  if (isCollapseMenu.value) {
    newExpandedKeys.value = getTreeDataKeys(props.treeData!)
  } else {
    newExpandedKeys.value = []
  }
}
// 输入框内容change
const handleSearchInputChange = (v: string) => {
  props.onSearchInputChange && props.onSearchInputChange(v)
}
// 点击头部add
const handleClickAddBtn = () => emits('clickAdd')
// 树展开
const handleTreeExpand = (expandedKeys: string[], data: any) => {
  emits('expand', expandedKeys, data)
}
// 树节点选择
const handleTreeSelect = (keys: string[], e: any) => {
  emits('select', keys, e)
}
// 点击弹窗的ok按钮
const handleClickOkBtn = () => emits('ok')
// 点击弹窗的cacel按钮
const handleClickCancelBtn = () => emits('cancel')
// 点击抽屉的x
const handleClickCloseBtn = () => emits('close')

// 6.watch
// 如果有数据并且输入框有内容则展开
watch(
  () => props.expandedKeys,
  keys => {
    if (keys) {
      newExpandedKeys.value = keys
    }
  },
  {
    deep: true
  }
)
</script>
